import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { TriggerTimeType } from '../../../app/types';
import { setNodeData } from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    block: {
      display: 'flex',
      alignItems: 'center',
    },
    option: {
      marginRight: 36,
      marginBottom: 12,
    },
    radioInput: {
      fontSize: 15,
    },
    radio: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$13,
    },
    dropdown: {
      width: 80,
      marginRight: 8,
    },
    time: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$13,
    },
  },
  {
    name: 'Time',
  },
);

const dayItem = [
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8', value: 8 },
  { text: '9', value: 9 },
  { text: '10', value: 10 },
  { text: '11', value: 11 },
  { text: '12', value: 12 },
  { text: '13', value: 13 },
  { text: '14', value: 14 },
  { text: '15', value: 15 },
  { text: '16', value: 16 },
  { text: '17', value: 17 },
  { text: '18', value: 18 },
  { text: '19', value: 19 },
  { text: '20', value: 20 },
  { text: '21', value: 21 },
  { text: '22', value: 22 },
  { text: '23', value: 23 },
  { text: '24', value: 24 },
  { text: '25', value: 25 },
  { text: '26', value: 26 },
  { text: '27', value: 27 },
  { text: '28', value: 28 },
  { text: '29', value: 29 },
  { text: '30', value: 30 },
];

const hourItem = [
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8', value: 8 },
  { text: '9', value: 9 },
  { text: '10', value: 10 },
  { text: '11', value: 11 },
  { text: '12', value: 12 },
  { text: '13', value: 13 },
  { text: '14', value: 14 },
  { text: '15', value: 15 },
  { text: '16', value: 16 },
  { text: '17', value: 17 },
  { text: '18', value: 18 },
  { text: '19', value: 19 },
  { text: '20', value: 20 },
  { text: '21', value: 21 },
  { text: '22', value: 22 },
  { text: '23', value: 23 },
];

const minuteItem = [
  { text: '5', value: 5 },
  { text: '10', value: 10 },
  { text: '15', value: 15 },
  { text: '20', value: 20 },
  { text: '25', value: 25 },
  { text: '30', value: 30 },
  { text: '35', value: 35 },
  { text: '40', value: 40 },
  { text: '45', value: 45 },
  { text: '50', value: 50 },
  { text: '55', value: 55 },
];

const Time = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [radioType, setRadioType] = useState(TriggerTimeType.DAY);
  const [day, setDay] = useState(1);
  const [hour, setHour] = useState(1);
  const [minute, setMinute] = useState(5);
  const { selectedNode } = useSelector(state => state.ma);
  const { timeType, time } = selectedNode?.data;

  const onChange = value => {
    if (value === TriggerTimeType.DAY) {
      dispatch(
        setNodeData({
          timeType: value,
          time: 86400,
        }),
      );
    } else if (value === TriggerTimeType.HOUR) {
      dispatch(
        setNodeData({
          timeType: value,
          time: 3600,
        }),
      );
    } else if (value === TriggerTimeType.MINUTE) {
      dispatch(
        setNodeData({
          timeType: value,
          time: 300,
        }),
      );
    }
  };

  const onDayChange = value => {
    dispatch(
      setNodeData({
        time: parseInt(value || 0, 10) * 24 * 60 * 60,
      }),
    );
  };

  const onHourChange = value => {
    dispatch(
      setNodeData({
        time: parseInt(value || 0, 10) * 60 * 60,
      }),
    );
  };

  const onMinuteChange = value => {
    dispatch(
      setNodeData({
        time: parseInt(value || 0, 10) * 60,
      }),
    );
  };

  useEffect(() => {
    setRadioType(timeType);
  }, [timeType]);

  useEffect(() => {
    if (time) {
      if (timeType === TriggerTimeType.DAY) {
        setDay(parseInt(time / 60 / 1440, 10));
        setHour(1);
        setMinute(5);
      }
      if (timeType === TriggerTimeType.HOUR) {
        setDay(1);
        setHour(parseInt(((time / 60) % 1440) / 60, 10));
        setMinute(5);
      }
      if (timeType === TriggerTimeType.MINUTE) {
        setDay(1);
        setHour(1);
        setMinute(parseInt(time / 60, 10));
      }
    }
  }, [time, timeType]);

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.time')}</div>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="default-display"
          name="default-display"
          value={radioType}
          onChange={e => {
            e.stopPropagation();
            onChange(e?.target?.value);
          }}
        >
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value={TriggerTimeType.DAY}
            control={<Radio color="primary" />}
            label={
              <div className={classes.time}>
                <Dropdown
                  className={classes.dropdown}
                  menuItems={dayItem}
                  value={day}
                  onChange={onDayChange}
                  disabled={
                    timeType === TriggerTimeType.HOUR ||
                    timeType === TriggerTimeType.MINUTE
                  }
                />
                {t('condition-setting.day')}
              </div>
            }
          />
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value={TriggerTimeType.HOUR}
            control={<Radio color="primary" />}
            label={
              <div className={classes.time}>
                <Dropdown
                  className={classes.dropdown}
                  menuItems={hourItem}
                  value={hour}
                  onChange={onHourChange}
                  disabled={
                    timeType === TriggerTimeType.DAY ||
                    timeType === TriggerTimeType.MINUTE
                  }
                />
                {t('condition-setting.hour')}
              </div>
            }
          />
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value={TriggerTimeType.MINUTE}
            control={<Radio color="primary" />}
            label={
              <div className={classes.time}>
                <Dropdown
                  className={classes.dropdown}
                  menuItems={minuteItem}
                  value={minute}
                  onChange={onMinuteChange}
                  disabled={
                    timeType === TriggerTimeType.DAY ||
                    timeType === TriggerTimeType.HOUR
                  }
                />
                {t('condition-setting.minute')}
              </div>
            }
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default Time;
